<template>
  <div
    class="page_middle_container page_middle_project_detail" style="padding: 0;"
  >
    <div class="page_middle_content" style="background-color: #dfeef4;">
      <div class="page_middle_title" style="padding: 3vw;margin-bottom: 0;">内部费用审核</div>
      <div class="page_middle_body">
        <div style="padding:4vw">
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                 <spaceBetweenLabel label="项目号"></spaceBetweenLabel>
              </div>
              <div class="page_middle_row_value">
                <el-input :disabled="true" v-model="data.project_number">
                </el-input>
              </div>
            </div>
          </div>
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                <spaceBetweenLabel label="申请时间"></spaceBetweenLabel>
              </div>
              <div class="page_middle_row_value">
                <el-date-picker
                  disabled
                  v-model="data.apply_time"
                  type="datetime"
                  placeholder="请选择申请时间"
                  size="small"
                />
              </div>
            </div>
          </div>
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                <spaceBetweenLabel label="申请事由"></spaceBetweenLabel>
              </div>
              <div class="page_middle_row_value">
                <el-input
                  :disabled="true"
                  type="textarea"
                  :autosize="{ minRows: 1, maxRows: 4 }"
                  v-model="data.expenses_reason"
                  :placeholder="getPlaceholder('请输入申请事由')"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <div style="padding:4vw;background-color: #fff;border-top-left-radius: 2.5vw;border-top-right-radius: 2.5vw;">
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_td_table">
                <div class="row_td_table_tr" style="background-color: #1e649e;color: #fff;">
                  <div class="row_td_table_td_type">费用类型</div>
                  <div class="row_td_table_td_detail">费用明细</div>
                  <div class="row_td_table_td_amount">金额</div>
                  <div class="row_td_table_td_name">员工</div>
                  <div class="row_td_table_td_notes"><span>备注</span><span>（数量,单价）</span></div>
                </div>
                <div class="row_td_table_tr" v-for="(item,index) in data.detail_list" :key="index" :class="index%2==0?'table_background':''">
                  <div class="row_td_table_td_type">{{item.expenses_type}}</div>
                  <div class="row_td_table_td_detail">{{item.expenses_detail}}</div>
                  <div class="row_td_table_td_amount">{{item.expenses_amount}}</div>
                  <div class="row_td_table_td_name">{{item.employee_name}}</div>
                  <div class="row_td_table_td_notes">{{ item.notes }}</div>
                </div>
                <div class="row_td_table_tr" v-if="data.detail_list.length == 0">
                  <div class="row_td_table_td_no_data">暂无数据</div>
                </div>
              </div>
            </div>
          </div>
          <div class="page_middle_row">
            <div class="page_middle_row_td" ref="total_table_td">
              <div class="page_middle_row_key pay_amount_block" :style="payAmountStyle">
                <img :src="require('@/assets/image/money_icon.png')" class="money_icon"/>
                <div class="pay_amount_label"><spaceBetweenLabel :isColon="false" :isRequire="false" :isBold="false" label="申请"></spaceBetweenLabel></div>
                <div class="pay_amount_label"><spaceBetweenLabel :isColon="false" :isRequire="false" :isBold="false" label="金额"></spaceBetweenLabel></div>
              </div>
              <div class="page_middle_row_value total_table" :class="applyMoneyTable.length%2==0?'even_number':'singular'">
                <el-table
                  :data="applyMoneyTable"
                  border
                  show-summary
                  :summary-method="$tools.getSumMoney"
                  :row-class-name="tableRowClassName"
                  :header-row-class-name="totalTableHeaderClass"
                  style="width: 100%;"
                >
                  <el-table-column label="员工">
                    <template #default="scope">
                      {{ scope.row.employee_name || "待选" }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="expenses_amount"
                    label="金额"
                    width="88"
                  />
                </el-table>
              </div>
            </div>
          </div>
          <div class="page_middle_row">
            <div class="page_middle_row_td" ref="invoice_td">
              <div class="page_middle_row_key pay_amount_block" :style="invoiceStyle">
                <div class="pay_amount_label"><spaceBetweenLabel :isColon="false" :isRequire="false" :isBold="false" label="发票"></spaceBetweenLabel></div>
                <div class="pay_amount_label"><spaceBetweenLabel :isColon="false" :isRequire="false" :isBold="false" label="附件"></spaceBetweenLabel></div>
              </div>
              <!-- <div class="page_middle_row_key" style="width: 19vw;">
                <spaceBetweenLabel :isRequire="false" label="发票附件:"></spaceBetweenLabel>
              </div> -->
              <div class="page_middle_row_value">
                <div v-if="data.invoice_attachment">
                  <div
                    style="margin-bottom: 5px;"
                    v-for="(item, index) in data.invoice_attachment.split(',')"
                    :key="index"
                  >
                    <span class="global_link" @click="openLink(item)">
                      {{ $tools.getFileNameFromURL(item) }}
                    </span>
                  </div>
                </div>
                <div v-else>无</div>
              </div>
            </div>
          </div>
          <div class="page_middle_row">
            <div class="page_middle_row_td"  ref="evidence_td">
              <div class="page_middle_row_key pay_amount_block" :style="evidenceStyle">
                <div class="pay_amount_label"><spaceBetweenLabel :isColon="false" :isRequire="false" :isBold="false" label="其他"></spaceBetweenLabel></div>
                <div class="pay_amount_label"><spaceBetweenLabel :isColon="false" :isRequire="false" :isBold="false" label="支付"></spaceBetweenLabel></div>
                <div class="pay_amount_label"><spaceBetweenLabel :isColon="false" :isRequire="false" :isBold="false" label="证明"></spaceBetweenLabel></div>
                <div class="pay_amount_label"><spaceBetweenLabel :isColon="false" :isRequire="false" :isBold="false" label="材料"></spaceBetweenLabel></div>
              </div>
              <!-- <div class="page_middle_row_key" style="width:25.5vw;">
                <spaceBetweenLabel :isRequire="false" label="其他支付证明材料:"></spaceBetweenLabel>
              </div> -->
              <div class="page_middle_row_value">
                <div v-if="data.evidence">
                  <div
                    style="margin-bottom: 5px;"
                    v-for="(item, index) in data.evidence.split(',')"
                    :key="index"
                  >
                    <span class="global_link" @click="openLink(item)">
                      {{ $tools.getFileNameFromURL(item) }}
                    </span>
                  </div>
                </div>
                <div v-else>无</div>
              </div>
            </div>
          </div>
          <div v-if="data.examine_status == 0 && !query.isWatch">
            <div class="page_middle_row">
              <div class="page_middle_row_td">
                <div class="page_middle_row_key">
                  <spaceBetweenLabel :isRequire="true" label="审批结果"></spaceBetweenLabel>
                </div>
                <div class="page_middle_row_value">
                  <el-select
                    v-model="auditData.examine_status"
                    placeholder="请选择审批结果"
                  >
                    <el-option :value="1" label="通过"></el-option>
                    <el-option :value="2" label="驳回"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="page_middle_row">
              <div class="page_middle_row_td">
                <div class="page_middle_row_key">
                  <spaceBetweenLabel :isRequire="auditData.examine_status == 2" 
                  :label="auditData.examine_status == 2?'审批备注':' 审批备注'"
                >
                </spaceBetweenLabel>
                </div>
                <div class="page_middle_row_value">
                  <el-input
                    v-model.trim="auditData.examine_reason"
                    placeholder="请输入审批备注"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="page_middle_row">
              <div class="page_middle_row_td">
                <div class="page_middle_row_key">
                  <spaceBetweenLabel :isRequire="false" label="审批结果"></spaceBetweenLabel>
                </div>
                <div class="page_middle_row_value" style="display: flex;align-items: center;">
                  <el-icon style="font-size: 4vw;color: #67c23a;margin-right: 5px;" v-if="data.examine_status == 1"><SuccessFilled /></el-icon>
                  <el-icon style="font-size: 4vw;color: red;margin-right: 5px;" v-if="data.examine_status == 2"><CircleCloseFilled /></el-icon>
                  <span>
                    {{ $config.types.auditResult[data.examine_status] }}
                  </span>
                </div>
              </div>
            </div>
            <div class="page_middle_row">
              <div class="page_middle_row_td">
                <div class="page_middle_row_key">
                  <spaceBetweenLabel :isRequire="false" label="审批备注"></spaceBetweenLabel>
                </div>
                <div class="page_middle_row_value">
                  {{ data.examine_reason }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="page_middle_buttongroup"
      v-if="data.examine_status == 0 && !query.isWatch"
    >
      <el-button type="primary" @click="doCommit" :loading="loading" size="small"
        >提交</el-button
      >
    </div>
  </div>
</template>
<script>
import '@/assets/css/applyCostAudit.css'
import { SuccessFilled, CircleCloseFilled } from "@element-plus/icons";
import spaceBetweenLabel from "@/components/unit/spaceBetweenLabel"
export default {
  name: "page_middle",
  //type 0 是内部费用 1 外部费用
  data() {
    return {
      auditData: {
        id: "",
        examine_status: "",
        examine_reason: "",
        operation_url: window.location.href,
      },
      data: {
        project_id: "",
        project_number: "", //项目号
        apply_time: "", //申请时间
        expenses_reason: "", //申请事由
        detail_list: [
          {
            employee_id: "",
            employee_name: "",
            expenses_type: "",
            expenses_detail: "",
            expenses_amount: 0,
            notes: "",
            attachment: "",
          },
        ],
        invoice_attachment: "",
        evidence: "",
      },
      config: {},
      is_second: 0, //是否二次审核(0:否，1:是)
      applyMoneyTable: [], //申请金额表
      detailData: {}, //上传附件的那一行数据
      expensesList: [], //费用类型列表
      expensesSet: [], //费用类型列表(去重)
      expensesDetail: [], //费用明细列表
      employeeList: [], //员工列表
      invoice_attachment: [], //发票附件
      evidence: [], //其他支付证明材料
      loading: false,
      payAmountStyle:"height:96px",
      invoiceStyle:"height:50px",
      evidenceStyle:"height:70px",
    };
  },
  components: {
    spaceBetweenLabel,
    SuccessFilled, 
    CircleCloseFilled 
  },
  created() {
    document.getElementsByTagName('title')[0].innerHTML = '内部费用审核'
    this.query = { ...this.$route.query };
    this.loadExpensesList();
    this.loadEmployee();
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.applyMoneyTable = [];
      let url = this.$tools.getURL(
        this.$urls.projectList.get_expenses_internal,
        { id: this.query.id }
      );
      this.$axios
        .get(url)
        .then((res) => {
          this.data = res.data;
          this.auditData.id = res.data.id;
          this.data.detail_list.forEach((e) => {
            let employee = this.applyMoneyTable.find(
              (x) => e.employee_id && x.employee_id == e.employee_id
            );
            if (employee) {
              employee.expenses_amount = Number(employee.expenses_amount) + Number(e.expenses_amount);
              employee.expenses_amount = employee.expenses_amount.toFixed(2);
            } else {
              let employeeObj = JSON.parse(JSON.stringify(e));
              this.applyMoneyTable.push(employeeObj);
            }
            this.refreshHeight()
          });
        })
        .catch((err) => {
          if (err.err.response.data.msg.includes("不存在")) {
            this.$router.push({
              path: "/auditError",
            });
          }
          console.log(err);
        });
    },
    refreshHeight(){
      this.$nextTick(()=>{
        this.payAmountStyle = `height:${this.$refs.total_table_td.clientHeight}px`;
        this.invoiceStyle = this.$refs.invoice_td.clientHeight<50 ? `height:50px` : `height:${this.$refs.invoice_td.clientHeight}px`;
        this.evidenceStyle = this.$refs.evidence_td.clientHeight<70 ? `height:70px` : `height:${this.$refs.evidence_td.clientHeight}px`;
      })
    },
    tableRowClassName({rowIndex}){
      console.log(rowIndex)
      if(rowIndex%2==1){
        return "table_background"
      }
      return ""
    },
    totalTableHeaderClass(){
      return "total_table_header_row"
    },
    //费用类型列表
    loadExpensesList() {
      this.$axios
        .get(this.$urls.projectList.expenses_type_list)
        .then((res) => {
          this.expensesList = res.data;
          let arr = res.data.map((x) => x.expenses_type);
          this.expensesSet = Array.from(new Set(arr));
          this.expensesDetail = [];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取员工列表
    loadEmployee() {
      let url = this.$tools.getURL(this.$urls.staffList.list, {
        page: 1,
        pagesize: 999,
      });
      this.$axios.get(url).then((res) => {
        this.employeeList = res.data;
      });
    },
    openLink(url) {
      this.$tools.downLoadFile(url);
    },
    getPlaceholder(text) {
      return text;
    },
    verifyData() {
      if (!this.auditData.examine_status) {
        this.$tips.error({ text: "请选择审批结果" });
        return false;
      }
      if (
        this.auditData.examine_status == 2 &&
        !this.auditData.examine_reason
      ) {
        this.$tips.error({ text: "请输入审批备注" });
        return false;
      }
      return true;
    },
    doCommit() {
      if (this.loading || !this.verifyData()) {
        return;
      }
      let url = this.$urls.projectList.expenses_internal_audit;
      this.loading = true;
      this.$axios
        .post(url, this.auditData)
        .then(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          this.$tips.success({ text: "审核完成" });
          this.initData();
        })
        .catch(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
  },
};
</script>
<style>
</style>
  